export default "__VITE_ASSET__be8c3c8c__"